/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreatePricingPageContent = /* GraphQL */ `
  subscription OnCreatePricingPageContent(
    $filter: ModelSubscriptionPricingPageContentFilterInput
  ) {
    onCreatePricingPageContent(filter: $filter) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePricingPageContent = /* GraphQL */ `
  subscription OnUpdatePricingPageContent(
    $filter: ModelSubscriptionPricingPageContentFilterInput
  ) {
    onUpdatePricingPageContent(filter: $filter) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePricingPageContent = /* GraphQL */ `
  subscription OnDeletePricingPageContent(
    $filter: ModelSubscriptionPricingPageContentFilterInput
  ) {
    onDeletePricingPageContent(filter: $filter) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const onCreateNotice = /* GraphQL */ `
  subscription OnCreateNotice($filter: ModelSubscriptionNoticeFilterInput) {
    onCreateNotice(filter: $filter) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateNotice = /* GraphQL */ `
  subscription OnUpdateNotice($filter: ModelSubscriptionNoticeFilterInput) {
    onUpdateNotice(filter: $filter) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteNotice = /* GraphQL */ `
  subscription OnDeleteNotice($filter: ModelSubscriptionNoticeFilterInput) {
    onDeleteNotice(filter: $filter) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFeedback = /* GraphQL */ `
  subscription OnCreateFeedback(
    $filter: ModelSubscriptionFeedbackFilterInput
    $owner: String
  ) {
    onCreateFeedback(filter: $filter, owner: $owner) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const onUpdateFeedback = /* GraphQL */ `
  subscription OnUpdateFeedback(
    $filter: ModelSubscriptionFeedbackFilterInput
    $owner: String
  ) {
    onUpdateFeedback(filter: $filter, owner: $owner) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const onDeleteFeedback = /* GraphQL */ `
  subscription OnDeleteFeedback(
    $filter: ModelSubscriptionFeedbackFilterInput
    $owner: String
  ) {
    onDeleteFeedback(filter: $filter, owner: $owner) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const onCreateUserProfile = /* GraphQL */ `
  subscription OnCreateUserProfile(
    $filter: ModelSubscriptionUserProfileFilterInput
    $owner: String
  ) {
    onCreateUserProfile(filter: $filter, owner: $owner) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateUserProfile = /* GraphQL */ `
  subscription OnUpdateUserProfile(
    $filter: ModelSubscriptionUserProfileFilterInput
    $owner: String
  ) {
    onUpdateUserProfile(filter: $filter, owner: $owner) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteUserProfile = /* GraphQL */ `
  subscription OnDeleteUserProfile(
    $filter: ModelSubscriptionUserProfileFilterInput
    $owner: String
  ) {
    onDeleteUserProfile(filter: $filter, owner: $owner) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateMemberAccess = /* GraphQL */ `
  subscription OnCreateMemberAccess(
    $filter: ModelSubscriptionMemberAccessFilterInput
    $userID: String
  ) {
    onCreateMemberAccess(filter: $filter, userID: $userID) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateMemberAccess = /* GraphQL */ `
  subscription OnUpdateMemberAccess(
    $filter: ModelSubscriptionMemberAccessFilterInput
    $userID: String
  ) {
    onUpdateMemberAccess(filter: $filter, userID: $userID) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteMemberAccess = /* GraphQL */ `
  subscription OnDeleteMemberAccess(
    $filter: ModelSubscriptionMemberAccessFilterInput
    $userID: String
  ) {
    onDeleteMemberAccess(filter: $filter, userID: $userID) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShowSeries = /* GraphQL */ `
  subscription OnCreateShowSeries(
    $filter: ModelSubscriptionShowSeriesFilterInput
  ) {
    onCreateShowSeries(filter: $filter) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShowSeries = /* GraphQL */ `
  subscription OnUpdateShowSeries(
    $filter: ModelSubscriptionShowSeriesFilterInput
  ) {
    onUpdateShowSeries(filter: $filter) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShowSeries = /* GraphQL */ `
  subscription OnDeleteShowSeries(
    $filter: ModelSubscriptionShowSeriesFilterInput
  ) {
    onDeleteShowSeries(filter: $filter) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShowEpisode = /* GraphQL */ `
  subscription OnCreateShowEpisode(
    $filter: ModelSubscriptionShowEpisodeFilterInput
  ) {
    onCreateShowEpisode(filter: $filter) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShowEpisode = /* GraphQL */ `
  subscription OnUpdateShowEpisode(
    $filter: ModelSubscriptionShowEpisodeFilterInput
  ) {
    onUpdateShowEpisode(filter: $filter) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShowEpisode = /* GraphQL */ `
  subscription OnDeleteShowEpisode(
    $filter: ModelSubscriptionShowEpisodeFilterInput
  ) {
    onDeleteShowEpisode(filter: $filter) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInstructor = /* GraphQL */ `
  subscription OnCreateInstructor(
    $filter: ModelSubscriptionInstructorFilterInput
  ) {
    onCreateInstructor(filter: $filter) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInstructor = /* GraphQL */ `
  subscription OnUpdateInstructor(
    $filter: ModelSubscriptionInstructorFilterInput
  ) {
    onUpdateInstructor(filter: $filter) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInstructor = /* GraphQL */ `
  subscription OnDeleteInstructor(
    $filter: ModelSubscriptionInstructorFilterInput
  ) {
    onDeleteInstructor(filter: $filter) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCourse = /* GraphQL */ `
  subscription OnCreateCourse($filter: ModelSubscriptionCourseFilterInput) {
    onCreateCourse(filter: $filter) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCourse = /* GraphQL */ `
  subscription OnUpdateCourse($filter: ModelSubscriptionCourseFilterInput) {
    onUpdateCourse(filter: $filter) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCourse = /* GraphQL */ `
  subscription OnDeleteCourse($filter: ModelSubscriptionCourseFilterInput) {
    onDeleteCourse(filter: $filter) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCourseModule = /* GraphQL */ `
  subscription OnCreateCourseModule(
    $filter: ModelSubscriptionCourseModuleFilterInput
  ) {
    onCreateCourseModule(filter: $filter) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCourseModule = /* GraphQL */ `
  subscription OnUpdateCourseModule(
    $filter: ModelSubscriptionCourseModuleFilterInput
  ) {
    onUpdateCourseModule(filter: $filter) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCourseModule = /* GraphQL */ `
  subscription OnDeleteCourseModule(
    $filter: ModelSubscriptionCourseModuleFilterInput
  ) {
    onDeleteCourseModule(filter: $filter) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLesson = /* GraphQL */ `
  subscription OnCreateLesson($filter: ModelSubscriptionLessonFilterInput) {
    onCreateLesson(filter: $filter) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateLesson = /* GraphQL */ `
  subscription OnUpdateLesson($filter: ModelSubscriptionLessonFilterInput) {
    onUpdateLesson(filter: $filter) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteLesson = /* GraphQL */ `
  subscription OnDeleteLesson($filter: ModelSubscriptionLessonFilterInput) {
    onDeleteLesson(filter: $filter) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLessonView = /* GraphQL */ `
  subscription OnCreateLessonView(
    $filter: ModelSubscriptionLessonViewFilterInput
  ) {
    onCreateLessonView(filter: $filter) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateLessonView = /* GraphQL */ `
  subscription OnUpdateLessonView(
    $filter: ModelSubscriptionLessonViewFilterInput
  ) {
    onUpdateLessonView(filter: $filter) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteLessonView = /* GraphQL */ `
  subscription OnDeleteLessonView(
    $filter: ModelSubscriptionLessonViewFilterInput
  ) {
    onDeleteLessonView(filter: $filter) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLessonComment = /* GraphQL */ `
  subscription OnCreateLessonComment(
    $filter: ModelSubscriptionLessonCommentFilterInput
    $owner: String
  ) {
    onCreateLessonComment(filter: $filter, owner: $owner) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateLessonComment = /* GraphQL */ `
  subscription OnUpdateLessonComment(
    $filter: ModelSubscriptionLessonCommentFilterInput
    $owner: String
  ) {
    onUpdateLessonComment(filter: $filter, owner: $owner) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteLessonComment = /* GraphQL */ `
  subscription OnDeleteLessonComment(
    $filter: ModelSubscriptionLessonCommentFilterInput
    $owner: String
  ) {
    onDeleteLessonComment(filter: $filter, owner: $owner) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateLessonCommentLike = /* GraphQL */ `
  subscription OnCreateLessonCommentLike(
    $filter: ModelSubscriptionLessonCommentLikeFilterInput
    $owner: String
  ) {
    onCreateLessonCommentLike(filter: $filter, owner: $owner) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateLessonCommentLike = /* GraphQL */ `
  subscription OnUpdateLessonCommentLike(
    $filter: ModelSubscriptionLessonCommentLikeFilterInput
    $owner: String
  ) {
    onUpdateLessonCommentLike(filter: $filter, owner: $owner) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteLessonCommentLike = /* GraphQL */ `
  subscription OnDeleteLessonCommentLike(
    $filter: ModelSubscriptionLessonCommentLikeFilterInput
    $owner: String
  ) {
    onDeleteLessonCommentLike(filter: $filter, owner: $owner) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateLessonCommentReport = /* GraphQL */ `
  subscription OnCreateLessonCommentReport(
    $filter: ModelSubscriptionLessonCommentReportFilterInput
    $owner: String
  ) {
    onCreateLessonCommentReport(filter: $filter, owner: $owner) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateLessonCommentReport = /* GraphQL */ `
  subscription OnUpdateLessonCommentReport(
    $filter: ModelSubscriptionLessonCommentReportFilterInput
    $owner: String
  ) {
    onUpdateLessonCommentReport(filter: $filter, owner: $owner) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteLessonCommentReport = /* GraphQL */ `
  subscription OnDeleteLessonCommentReport(
    $filter: ModelSubscriptionLessonCommentReportFilterInput
    $owner: String
  ) {
    onDeleteLessonCommentReport(filter: $filter, owner: $owner) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateLessonProgress = /* GraphQL */ `
  subscription OnCreateLessonProgress(
    $filter: ModelSubscriptionLessonProgressFilterInput
    $owner: String
  ) {
    onCreateLessonProgress(filter: $filter, owner: $owner) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateLessonProgress = /* GraphQL */ `
  subscription OnUpdateLessonProgress(
    $filter: ModelSubscriptionLessonProgressFilterInput
    $owner: String
  ) {
    onUpdateLessonProgress(filter: $filter, owner: $owner) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteLessonProgress = /* GraphQL */ `
  subscription OnDeleteLessonProgress(
    $filter: ModelSubscriptionLessonProgressFilterInput
    $owner: String
  ) {
    onDeleteLessonProgress(filter: $filter, owner: $owner) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateVibePointTransaction = /* GraphQL */ `
  subscription OnCreateVibePointTransaction(
    $filter: ModelSubscriptionVibePointTransactionFilterInput
    $owner: String
  ) {
    onCreateVibePointTransaction(filter: $filter, owner: $owner) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateVibePointTransaction = /* GraphQL */ `
  subscription OnUpdateVibePointTransaction(
    $filter: ModelSubscriptionVibePointTransactionFilterInput
    $owner: String
  ) {
    onUpdateVibePointTransaction(filter: $filter, owner: $owner) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteVibePointTransaction = /* GraphQL */ `
  subscription OnDeleteVibePointTransaction(
    $filter: ModelSubscriptionVibePointTransactionFilterInput
    $owner: String
  ) {
    onDeleteVibePointTransaction(filter: $filter, owner: $owner) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateUserNotification = /* GraphQL */ `
  subscription OnCreateUserNotification(
    $filter: ModelSubscriptionUserNotificationFilterInput
    $userID: String
  ) {
    onCreateUserNotification(filter: $filter, userID: $userID) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateUserNotification = /* GraphQL */ `
  subscription OnUpdateUserNotification(
    $filter: ModelSubscriptionUserNotificationFilterInput
    $userID: String
  ) {
    onUpdateUserNotification(filter: $filter, userID: $userID) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteUserNotification = /* GraphQL */ `
  subscription OnDeleteUserNotification(
    $filter: ModelSubscriptionUserNotificationFilterInput
    $userID: String
  ) {
    onDeleteUserNotification(filter: $filter, userID: $userID) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const onCreateStudentVideo = /* GraphQL */ `
  subscription OnCreateStudentVideo(
    $filter: ModelSubscriptionStudentVideoFilterInput
    $owner: String
  ) {
    onCreateStudentVideo(filter: $filter, owner: $owner) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentVideo = /* GraphQL */ `
  subscription OnUpdateStudentVideo(
    $filter: ModelSubscriptionStudentVideoFilterInput
    $owner: String
  ) {
    onUpdateStudentVideo(filter: $filter, owner: $owner) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentVideo = /* GraphQL */ `
  subscription OnDeleteStudentVideo(
    $filter: ModelSubscriptionStudentVideoFilterInput
    $owner: String
  ) {
    onDeleteStudentVideo(filter: $filter, owner: $owner) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateStudentVideoLike = /* GraphQL */ `
  subscription OnCreateStudentVideoLike(
    $filter: ModelSubscriptionStudentVideoLikeFilterInput
    $owner: String
  ) {
    onCreateStudentVideoLike(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentVideoLike = /* GraphQL */ `
  subscription OnUpdateStudentVideoLike(
    $filter: ModelSubscriptionStudentVideoLikeFilterInput
    $owner: String
  ) {
    onUpdateStudentVideoLike(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentVideoLike = /* GraphQL */ `
  subscription OnDeleteStudentVideoLike(
    $filter: ModelSubscriptionStudentVideoLikeFilterInput
    $owner: String
  ) {
    onDeleteStudentVideoLike(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateStudentVideoComment = /* GraphQL */ `
  subscription OnCreateStudentVideoComment(
    $filter: ModelSubscriptionStudentVideoCommentFilterInput
    $owner: String
  ) {
    onCreateStudentVideoComment(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentVideoComment = /* GraphQL */ `
  subscription OnUpdateStudentVideoComment(
    $filter: ModelSubscriptionStudentVideoCommentFilterInput
    $owner: String
  ) {
    onUpdateStudentVideoComment(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentVideoComment = /* GraphQL */ `
  subscription OnDeleteStudentVideoComment(
    $filter: ModelSubscriptionStudentVideoCommentFilterInput
    $owner: String
  ) {
    onDeleteStudentVideoComment(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateStudentPublicProfile = /* GraphQL */ `
  subscription OnCreateStudentPublicProfile(
    $filter: ModelSubscriptionStudentPublicProfileFilterInput
    $owner: String
  ) {
    onCreateStudentPublicProfile(filter: $filter, owner: $owner) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const onUpdateStudentPublicProfile = /* GraphQL */ `
  subscription OnUpdateStudentPublicProfile(
    $filter: ModelSubscriptionStudentPublicProfileFilterInput
    $owner: String
  ) {
    onUpdateStudentPublicProfile(filter: $filter, owner: $owner) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const onDeleteStudentPublicProfile = /* GraphQL */ `
  subscription OnDeleteStudentPublicProfile(
    $filter: ModelSubscriptionStudentPublicProfileFilterInput
    $owner: String
  ) {
    onDeleteStudentPublicProfile(filter: $filter, owner: $owner) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const onCreateStudentFollow = /* GraphQL */ `
  subscription OnCreateStudentFollow(
    $filter: ModelSubscriptionStudentFollowFilterInput
    $owner: String
  ) {
    onCreateStudentFollow(filter: $filter, owner: $owner) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentFollow = /* GraphQL */ `
  subscription OnUpdateStudentFollow(
    $filter: ModelSubscriptionStudentFollowFilterInput
    $owner: String
  ) {
    onUpdateStudentFollow(filter: $filter, owner: $owner) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentFollow = /* GraphQL */ `
  subscription OnDeleteStudentFollow(
    $filter: ModelSubscriptionStudentFollowFilterInput
    $owner: String
  ) {
    onDeleteStudentFollow(filter: $filter, owner: $owner) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateStudentVideoBookmark = /* GraphQL */ `
  subscription OnCreateStudentVideoBookmark(
    $filter: ModelSubscriptionStudentVideoBookmarkFilterInput
    $owner: String
  ) {
    onCreateStudentVideoBookmark(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentVideoBookmark = /* GraphQL */ `
  subscription OnUpdateStudentVideoBookmark(
    $filter: ModelSubscriptionStudentVideoBookmarkFilterInput
    $owner: String
  ) {
    onUpdateStudentVideoBookmark(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentVideoBookmark = /* GraphQL */ `
  subscription OnDeleteStudentVideoBookmark(
    $filter: ModelSubscriptionStudentVideoBookmarkFilterInput
    $owner: String
  ) {
    onDeleteStudentVideoBookmark(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateStudentVideoView = /* GraphQL */ `
  subscription OnCreateStudentVideoView(
    $filter: ModelSubscriptionStudentVideoViewFilterInput
    $owner: String
  ) {
    onCreateStudentVideoView(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentVideoView = /* GraphQL */ `
  subscription OnUpdateStudentVideoView(
    $filter: ModelSubscriptionStudentVideoViewFilterInput
    $owner: String
  ) {
    onUpdateStudentVideoView(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentVideoView = /* GraphQL */ `
  subscription OnDeleteStudentVideoView(
    $filter: ModelSubscriptionStudentVideoViewFilterInput
    $owner: String
  ) {
    onDeleteStudentVideoView(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateStudentVideoFeature = /* GraphQL */ `
  subscription OnCreateStudentVideoFeature(
    $filter: ModelSubscriptionStudentVideoFeatureFilterInput
  ) {
    onCreateStudentVideoFeature(filter: $filter) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateStudentVideoFeature = /* GraphQL */ `
  subscription OnUpdateStudentVideoFeature(
    $filter: ModelSubscriptionStudentVideoFeatureFilterInput
  ) {
    onUpdateStudentVideoFeature(filter: $filter) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteStudentVideoFeature = /* GraphQL */ `
  subscription OnDeleteStudentVideoFeature(
    $filter: ModelSubscriptionStudentVideoFeatureFilterInput
  ) {
    onDeleteStudentVideoFeature(filter: $filter) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateStudentModerationAction = /* GraphQL */ `
  subscription OnCreateStudentModerationAction(
    $filter: ModelSubscriptionStudentModerationActionFilterInput
    $userID: String
  ) {
    onCreateStudentModerationAction(filter: $filter, userID: $userID) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateStudentModerationAction = /* GraphQL */ `
  subscription OnUpdateStudentModerationAction(
    $filter: ModelSubscriptionStudentModerationActionFilterInput
    $userID: String
  ) {
    onUpdateStudentModerationAction(filter: $filter, userID: $userID) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteStudentModerationAction = /* GraphQL */ `
  subscription OnDeleteStudentModerationAction(
    $filter: ModelSubscriptionStudentModerationActionFilterInput
    $userID: String
  ) {
    onDeleteStudentModerationAction(filter: $filter, userID: $userID) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const onCreateStudentVideoReport = /* GraphQL */ `
  subscription OnCreateStudentVideoReport(
    $filter: ModelSubscriptionStudentVideoReportFilterInput
    $owner: String
  ) {
    onCreateStudentVideoReport(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateStudentVideoReport = /* GraphQL */ `
  subscription OnUpdateStudentVideoReport(
    $filter: ModelSubscriptionStudentVideoReportFilterInput
    $owner: String
  ) {
    onUpdateStudentVideoReport(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteStudentVideoReport = /* GraphQL */ `
  subscription OnDeleteStudentVideoReport(
    $filter: ModelSubscriptionStudentVideoReportFilterInput
    $owner: String
  ) {
    onDeleteStudentVideoReport(filter: $filter, owner: $owner) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateJourneyTrack = /* GraphQL */ `
  subscription OnCreateJourneyTrack(
    $filter: ModelSubscriptionJourneyTrackFilterInput
  ) {
    onCreateJourneyTrack(filter: $filter) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateJourneyTrack = /* GraphQL */ `
  subscription OnUpdateJourneyTrack(
    $filter: ModelSubscriptionJourneyTrackFilterInput
  ) {
    onUpdateJourneyTrack(filter: $filter) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteJourneyTrack = /* GraphQL */ `
  subscription OnDeleteJourneyTrack(
    $filter: ModelSubscriptionJourneyTrackFilterInput
  ) {
    onDeleteJourneyTrack(filter: $filter) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateJourneyUnit = /* GraphQL */ `
  subscription OnCreateJourneyUnit(
    $filter: ModelSubscriptionJourneyUnitFilterInput
  ) {
    onCreateJourneyUnit(filter: $filter) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateJourneyUnit = /* GraphQL */ `
  subscription OnUpdateJourneyUnit(
    $filter: ModelSubscriptionJourneyUnitFilterInput
  ) {
    onUpdateJourneyUnit(filter: $filter) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteJourneyUnit = /* GraphQL */ `
  subscription OnDeleteJourneyUnit(
    $filter: ModelSubscriptionJourneyUnitFilterInput
  ) {
    onDeleteJourneyUnit(filter: $filter) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateJourneyNode = /* GraphQL */ `
  subscription OnCreateJourneyNode(
    $filter: ModelSubscriptionJourneyNodeFilterInput
  ) {
    onCreateJourneyNode(filter: $filter) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateJourneyNode = /* GraphQL */ `
  subscription OnUpdateJourneyNode(
    $filter: ModelSubscriptionJourneyNodeFilterInput
  ) {
    onUpdateJourneyNode(filter: $filter) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteJourneyNode = /* GraphQL */ `
  subscription OnDeleteJourneyNode(
    $filter: ModelSubscriptionJourneyNodeFilterInput
  ) {
    onDeleteJourneyNode(filter: $filter) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateJourneyLesson = /* GraphQL */ `
  subscription OnCreateJourneyLesson(
    $filter: ModelSubscriptionJourneyLessonFilterInput
  ) {
    onCreateJourneyLesson(filter: $filter) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateJourneyLesson = /* GraphQL */ `
  subscription OnUpdateJourneyLesson(
    $filter: ModelSubscriptionJourneyLessonFilterInput
  ) {
    onUpdateJourneyLesson(filter: $filter) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteJourneyLesson = /* GraphQL */ `
  subscription OnDeleteJourneyLesson(
    $filter: ModelSubscriptionJourneyLessonFilterInput
  ) {
    onDeleteJourneyLesson(filter: $filter) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateJourneyQuizQuestion = /* GraphQL */ `
  subscription OnCreateJourneyQuizQuestion(
    $filter: ModelSubscriptionJourneyQuizQuestionFilterInput
  ) {
    onCreateJourneyQuizQuestion(filter: $filter) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateJourneyQuizQuestion = /* GraphQL */ `
  subscription OnUpdateJourneyQuizQuestion(
    $filter: ModelSubscriptionJourneyQuizQuestionFilterInput
  ) {
    onUpdateJourneyQuizQuestion(filter: $filter) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteJourneyQuizQuestion = /* GraphQL */ `
  subscription OnDeleteJourneyQuizQuestion(
    $filter: ModelSubscriptionJourneyQuizQuestionFilterInput
  ) {
    onDeleteJourneyQuizQuestion(filter: $filter) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateJourneyNodeProgress = /* GraphQL */ `
  subscription OnCreateJourneyNodeProgress(
    $filter: ModelSubscriptionJourneyNodeProgressFilterInput
    $owner: String
  ) {
    onCreateJourneyNodeProgress(filter: $filter, owner: $owner) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateJourneyNodeProgress = /* GraphQL */ `
  subscription OnUpdateJourneyNodeProgress(
    $filter: ModelSubscriptionJourneyNodeProgressFilterInput
    $owner: String
  ) {
    onUpdateJourneyNodeProgress(filter: $filter, owner: $owner) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteJourneyNodeProgress = /* GraphQL */ `
  subscription OnDeleteJourneyNodeProgress(
    $filter: ModelSubscriptionJourneyNodeProgressFilterInput
    $owner: String
  ) {
    onDeleteJourneyNodeProgress(filter: $filter, owner: $owner) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateDanceChallenge = /* GraphQL */ `
  subscription OnCreateDanceChallenge(
    $filter: ModelSubscriptionDanceChallengeFilterInput
  ) {
    onCreateDanceChallenge(filter: $filter) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDanceChallenge = /* GraphQL */ `
  subscription OnUpdateDanceChallenge(
    $filter: ModelSubscriptionDanceChallengeFilterInput
  ) {
    onUpdateDanceChallenge(filter: $filter) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDanceChallenge = /* GraphQL */ `
  subscription OnDeleteDanceChallenge(
    $filter: ModelSubscriptionDanceChallengeFilterInput
  ) {
    onDeleteDanceChallenge(filter: $filter) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const onCreateChallengeQuiz = /* GraphQL */ `
  subscription OnCreateChallengeQuiz(
    $filter: ModelSubscriptionChallengeQuizFilterInput
  ) {
    onCreateChallengeQuiz(filter: $filter) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChallengeQuiz = /* GraphQL */ `
  subscription OnUpdateChallengeQuiz(
    $filter: ModelSubscriptionChallengeQuizFilterInput
  ) {
    onUpdateChallengeQuiz(filter: $filter) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChallengeQuiz = /* GraphQL */ `
  subscription OnDeleteChallengeQuiz(
    $filter: ModelSubscriptionChallengeQuizFilterInput
  ) {
    onDeleteChallengeQuiz(filter: $filter) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateChallengeQuizLibrarySettings = /* GraphQL */ `
  subscription OnCreateChallengeQuizLibrarySettings(
    $filter: ModelSubscriptionChallengeQuizLibrarySettingsFilterInput
  ) {
    onCreateChallengeQuizLibrarySettings(filter: $filter) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChallengeQuizLibrarySettings = /* GraphQL */ `
  subscription OnUpdateChallengeQuizLibrarySettings(
    $filter: ModelSubscriptionChallengeQuizLibrarySettingsFilterInput
  ) {
    onUpdateChallengeQuizLibrarySettings(filter: $filter) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChallengeQuizLibrarySettings = /* GraphQL */ `
  subscription OnDeleteChallengeQuizLibrarySettings(
    $filter: ModelSubscriptionChallengeQuizLibrarySettingsFilterInput
  ) {
    onDeleteChallengeQuizLibrarySettings(filter: $filter) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const onCreateChallengeQuizQuestion = /* GraphQL */ `
  subscription OnCreateChallengeQuizQuestion(
    $filter: ModelSubscriptionChallengeQuizQuestionFilterInput
  ) {
    onCreateChallengeQuizQuestion(filter: $filter) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChallengeQuizQuestion = /* GraphQL */ `
  subscription OnUpdateChallengeQuizQuestion(
    $filter: ModelSubscriptionChallengeQuizQuestionFilterInput
  ) {
    onUpdateChallengeQuizQuestion(filter: $filter) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChallengeQuizQuestion = /* GraphQL */ `
  subscription OnDeleteChallengeQuizQuestion(
    $filter: ModelSubscriptionChallengeQuizQuestionFilterInput
  ) {
    onDeleteChallengeQuizQuestion(filter: $filter) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const onCreateChallengeQuizAttempt = /* GraphQL */ `
  subscription OnCreateChallengeQuizAttempt(
    $filter: ModelSubscriptionChallengeQuizAttemptFilterInput
    $owner: String
  ) {
    onCreateChallengeQuizAttempt(filter: $filter, owner: $owner) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateChallengeQuizAttempt = /* GraphQL */ `
  subscription OnUpdateChallengeQuizAttempt(
    $filter: ModelSubscriptionChallengeQuizAttemptFilterInput
    $owner: String
  ) {
    onUpdateChallengeQuizAttempt(filter: $filter, owner: $owner) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteChallengeQuizAttempt = /* GraphQL */ `
  subscription OnDeleteChallengeQuizAttempt(
    $filter: ModelSubscriptionChallengeQuizAttemptFilterInput
    $owner: String
  ) {
    onDeleteChallengeQuizAttempt(filter: $filter, owner: $owner) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateChallengeSubmission = /* GraphQL */ `
  subscription OnCreateChallengeSubmission(
    $filter: ModelSubscriptionChallengeSubmissionFilterInput
    $owner: String
  ) {
    onCreateChallengeSubmission(filter: $filter, owner: $owner) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateChallengeSubmission = /* GraphQL */ `
  subscription OnUpdateChallengeSubmission(
    $filter: ModelSubscriptionChallengeSubmissionFilterInput
    $owner: String
  ) {
    onUpdateChallengeSubmission(filter: $filter, owner: $owner) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteChallengeSubmission = /* GraphQL */ `
  subscription OnDeleteChallengeSubmission(
    $filter: ModelSubscriptionChallengeSubmissionFilterInput
    $owner: String
  ) {
    onDeleteChallengeSubmission(filter: $filter, owner: $owner) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateChallengeLike = /* GraphQL */ `
  subscription OnCreateChallengeLike(
    $filter: ModelSubscriptionChallengeLikeFilterInput
    $owner: String
  ) {
    onCreateChallengeLike(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateChallengeLike = /* GraphQL */ `
  subscription OnUpdateChallengeLike(
    $filter: ModelSubscriptionChallengeLikeFilterInput
    $owner: String
  ) {
    onUpdateChallengeLike(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteChallengeLike = /* GraphQL */ `
  subscription OnDeleteChallengeLike(
    $filter: ModelSubscriptionChallengeLikeFilterInput
    $owner: String
  ) {
    onDeleteChallengeLike(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateChallengeView = /* GraphQL */ `
  subscription OnCreateChallengeView(
    $filter: ModelSubscriptionChallengeViewFilterInput
    $owner: String
  ) {
    onCreateChallengeView(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateChallengeView = /* GraphQL */ `
  subscription OnUpdateChallengeView(
    $filter: ModelSubscriptionChallengeViewFilterInput
    $owner: String
  ) {
    onUpdateChallengeView(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteChallengeView = /* GraphQL */ `
  subscription OnDeleteChallengeView(
    $filter: ModelSubscriptionChallengeViewFilterInput
    $owner: String
  ) {
    onDeleteChallengeView(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateChallengeReport = /* GraphQL */ `
  subscription OnCreateChallengeReport(
    $filter: ModelSubscriptionChallengeReportFilterInput
    $owner: String
  ) {
    onCreateChallengeReport(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateChallengeReport = /* GraphQL */ `
  subscription OnUpdateChallengeReport(
    $filter: ModelSubscriptionChallengeReportFilterInput
    $owner: String
  ) {
    onUpdateChallengeReport(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteChallengeReport = /* GraphQL */ `
  subscription OnDeleteChallengeReport(
    $filter: ModelSubscriptionChallengeReportFilterInput
    $owner: String
  ) {
    onDeleteChallengeReport(filter: $filter, owner: $owner) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
